


import React from 'react'
import { NavLink } from 'react-router-dom'
import { SlHome } from 'react-icons/sl'
import { BsWallet } from 'react-icons/bs'
import { FiUser, FiUsers } from 'react-icons/fi'
import { BiMessageSquareDetail } from 'react-icons/bi'

const Footer = () => {
  const access_token = localStorage.getItem('token');

  return (
    <>

      <div className="footer_main_div">
        <nav className="bottom_link_main">
          <NavLink
            to="/home"
            className={({ isActive }) =>
              isActive ? 'bottom_link active_link' : 'bottom_link'
            }
          >
            <SlHome className="sidebar_link_icon" />
            <span>Home</span>
          </NavLink>

          <NavLink
            to="/wallet"
            className={({ isActive }) =>
              isActive ? 'bottom_link active_link' : 'bottom_link'
            }
          >
            <BsWallet className="sidebar_link_icon" />
            <span>My Wallet</span>
          </NavLink>

          <NavLink
            to="/refer"
            className={({ isActive }) =>
              isActive ? 'bottom_link active_link' : 'bottom_link'
            }
          >
            <FiUsers className="sidebar_link_icon" />
            <span>Refer</span>
          </NavLink>

          <NavLink
            to="/support"
            className={({ isActive }) =>
              isActive ? 'bottom_link active_link' : 'bottom_link'
            }
          >
            <BiMessageSquareDetail className="sidebar_link_icon" />
            <span>Support</span>
          </NavLink>

          <NavLink
            to="/profile"
            className={({ isActive }) =>
              isActive ? 'bottom_link active_link' : 'bottom_link'
            }
          >
            <FiUser className="sidebar_link_icon" />
            <span>Profile</span>
          </NavLink>
        </nav>
      </div>


    </>
  )
}

export default Footer


